"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isBrowser } from '@autoguru/overdrive/dist/utils';
import { invariant } from '@autoguru/utilities';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const sharedContextName = '__AG_EXPAND_SIDE_NAV_CTX__';
const sharedContextObj = '__AG_EXPAND_SIDE_NAV_CTX_OBJ__';
const expandSideNavProviderContext = isBrowser && globalThis[sharedContextObj] || /*#__PURE__*/createContext(null);
export const useExpandSideNav = ({
  stringTokens
}) => {
  const contextValue = useContext(expandSideNavProviderContext) || isBrowser && globalThis[sharedContextName];
  useEffect(() => {
    if (stringTokens) contextValue === null || contextValue === void 0 || contextValue.setStringTokens(stringTokens);
  }, [contextValue === null || contextValue === void 0 ? void 0 : contextValue.setStringTokens, stringTokens]);
  !(contextValue !== null || process.env.NODE_ENV !== "production") ? process.env.NODE_ENV !== "production" ? invariant(false, 'Please have a <ExpandSideNavProvider /> set in your tree') : invariant(false) : void 0;
  return contextValue;
};
export const ExpandSideNavProvider = ({
  children,
  includeAuth,
  asideItems,
  labelClassName,
  stringTokens: incomingStringTokens,
  activeLinkChecker: incomingActiveLinkChecker,
  logoutRedirect,
  logoutUrl
}) => {
  const [stringTokens, setStringTokens] = useState(incomingStringTokens);
  const [viewerAccess, setViewerAccess] = useState([]);
  const [activeLinkChecker, setActiveLinkChecker] = useState(incomingActiveLinkChecker);
  const [isExpanded, setIsExpanded] = useState(false);
  const context = useMemo(() => ({
    asideItems,
    labelClassName,
    includeAuth,
    stringTokens,
    viewerAccess,
    logoutRedirect,
    logoutUrl,
    setStringTokens,
    activeLinkChecker,
    setActiveLinkChecker,
    setViewerAccess,
    isExpanded,
    setIsExpanded
  }), [asideItems, labelClassName, includeAuth, stringTokens, viewerAccess, logoutRedirect, logoutUrl, setStringTokens, activeLinkChecker, setActiveLinkChecker, isExpanded]);
  useEffect(() => {
    if (isBrowser) globalThis[sharedContextName] = context;
  }, [context]);
  return /*#__PURE__*/_jsx(expandSideNavProviderContext.Provider, {
    value: context,
    children: children
  });
};